export default __webpack_public_path__ + "static/media/classic2.cee6a38a.jpg";